import { render, staticRenderFns } from "./DataStructureTab.vue?vue&type=template&id=dd973782&"
import script from "./DataStructureTab.vue?vue&type=script&lang=ts&"
export * from "./DataStructureTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports